"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTypeAllowed = exports.types = void 0;

/* const schema = {
   name,     // Name of the event
   provider, // ClientWeb, MobileWeb, BackendService, OuterService
   context,  // AppId - InboxV2, ServiceName, Outer service Name
   type,     // Click, Hover, Data transferred, Request
   target    // Target of the action
 };
*/
var providers = new Set(['webclient, mobile']);
var types = new Set(['pageview', 'screenview', 'submit', 'click', 'hover', 'scroll', 'side-effect']);
exports.types = types;

var isTypeAllowed = function isTypeAllowed(type) {
  return !!type && types.has(type);
};

exports.isTypeAllowed = isTypeAllowed;